import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBack from '../assets/images/chevrons-left.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { forStudent } from '../Store/api/activities';
import Incomplete from '../assets/images/incomplete-circle.svg';
import Inprogress from '../assets/images/Inprogress.svg';
import InProgressLine from '../assets/images/Inprogress-line.png';
import Submitted from '../assets/images/submitted-circle.svg';
import Red from '../assets/images/red-circle.svg';
import Green from '../assets/images/green-circle.svg';
import YellowCircle from '../assets/images/yellow-circle.svg';
import { byBookActivityAnswer } from '../Store/api/activities';
import VerticalSolidLine from '../assets/images/verticalSolidline.svg';
import CompleteActivityDuetoNext from './CompleteActivityDuetoNext';
const SidebarMinmized = ({ activitiesByAssignedDate, complteDueNext, oepnedDate, setComplteDueNext, activity, shouldFetchActivity, setShouldFetchActivity, id, isBookExpanded, setIsBookExpanded, setTabs, tabContent }) => {
  const [openIndex, setOpenIndex] = useState(oepnedDate);
  const { book } = useSelector((state) => state.entities.student);
  const [activityByBook, setActivityByBook] = useState([]);
  const [loading, setLoading] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (activity && activity?.book) {
      setLoading(true); // Start loading

      /* dispatch(
              getBook({
                id: activity?.book,
                onSuccess: (res) => {
                  const bookData = res.data.data.book;
                  // Process bookData if needed
                },
                onError: (err) => {
                  setLoading(false); // End loading
                },
              })
            ); */

      // Fetch activities for the book when shouldFetchActivity changes

      dispatch(
        byBookActivityAnswer({
          id: activity?.book,
          onSuccess: (res) => {
            setActivityByBook(res.data.data);
            setLoading(false); // End loading
            setShouldFetchActivity(false); // Reset state after fetching
          },
          onError: (err) => {
            setLoading(false); // End loading
          },
        })
      );
    }
  }, [activity?.book, shouldFetchActivity]);

  const dispatch = useDispatch();
  useEffect(() => {
    setOpenIndex(oepnedDate);
  }, [oepnedDate]);
  useEffect(() => {
    dispatch(
      forStudent({
        onSuccess: (res) => {},
        onError: (err) => {},
      })
    );
  }, []);
  useEffect(() => {}, [activityByBook]);

  const calculateAveragePercentage = (activityAnswers) => {
    return activityAnswers.map((activityAnswer) => {
      const { grade, isGraded, answers, activityStatus } = activityAnswer;

      if (grade === 100 && isGraded) {
        return { color: 'Green', grade };
      } else if (grade >= 70 && grade < 100 && isGraded) {
        return { color: 'Yellow', grade };
      } else if (grade >= 0 && grade < 70 && isGraded) {
        return { color: 'Red', grade };
      }

      // Check for submitted and in-progress states
      if (!isGraded && answers?.length > 0) {
        if (activityStatus === 'InProgress') {
          return { color: 'inprogress', grade };
        } else {
          return { color: 'submit', grade };
        }
      }

      // Incomplete if there are no answers and it's not graded
      if (!isGraded && answers?.length === 0) {
        return { color: 'incomplete', grade };
      }

      return { color: 'Unknown', grade };
    });
  };

  const getCorrectImage = (activity) => {
    const result = calculateAveragePercentage(activity?.activityAnswers);
    const gradeResults = result.map((res) => res.color);

    if (gradeResults.includes('Red')) {
      return Red;
    } else if (gradeResults.includes('Yellow')) {
      return YellowCircle;
    } else if (gradeResults.includes('Green')) {
      return Green;
    } else if (gradeResults.includes('submit')) {
      return Submitted;
    } else if (gradeResults.includes('incomplete')) {
      return Incomplete;
    } else if (gradeResults.includes('inprogress')) {
      return Inprogress;
    }
  };

  const submitedActivities =
    activityByBook?.length > 0 ? (
      [...(activitiesByAssignedDate.filter((e) => e.activities.some((a) => a._id === id))[0]?.activities || [])]
        .sort((a, b) => {
          const dateA = new Date(a.assignedDate);
          const dateB = new Date(b.assignedDate);
          return dateB - dateA;
        })
        .map((obj, index, arr) => {
          const activityStatus = obj.activityAnswers[0]?.activityStatus;

          return (
            <div className='submited-circle' key={index}>
              <React.Fragment>
                <img src={getCorrectImage(obj)} alt='' />

                {/* Display InProgressLine if current activity status is "InProgress" and it's not the last item */}
                {activityStatus === 'InProgress' && index < arr.length - 1 && <img src={InProgressLine} alt='in-progress-line' className='inprogress-line' />}

                {/* Display a regular vertical line for non-in-progress activities except the last item */}
                {index < arr.length - 1 && activityStatus !== 'InProgress' && (
                  // <div className="vertical-line"></div>
                  <img src={VerticalSolidLine} alt='in-progress-line' className='inprogress-line' />
                )}
              </React.Fragment>
            </div>
          );
        })
    ) : (
      <div>Loading...</div>
    );

  return (
    <div className='gradding_side_bar minimized' style={{ width: '20%' }}>
      <div className='side_bar_wrapper'>
        <div className={`animation-sidebar-wrapper ${complteDueNext && !closing ? ' active' : !complteDueNext && closing ? 'inactive' : ''}`}>
          {/* <img src={ArrowBack} alt='' style={{ transform: 'rotate(-180deg)' }} onClick={() => setComplteDueNext(false)} /> */}
          <div className={`animation-sidebar  `}>
            {' '}
            <CompleteActivityDuetoNext setComplteDueNext={setComplteDueNext} activitiesByAssignedDate={activitiesByAssignedDate} mode='focus' setClosing={setClosing} />
          </div>
        </div>

        {!complteDueNext && !closing && (
          <div className='sidebar_top_buttons_wrapper'>
            <div className='maximize_wrapper cursor' style={{ marginBottom: '21px' }} onClick={() => setComplteDueNext(true)}>
              <img src={ArrowBack} alt='' />
              <div className='gradding_top mb-0'></div>
            </div>
            {submitedActivities}
          </div>
        )}
      </div>
      <div className='rightbar_strapps'>
        <div className='strap_1'></div>
        <div className='strap_2'></div>
        <div className='strap_3'></div>
      </div>
    </div>
  );
};

export default SidebarMinmized;
